import { UploadFilesForm } from '@/components/forms'
import {
    WelcomeModule,
    MeetUsModule,
    AboutYouModule,
    EnrollmentOrderModule,
    ProjectionModule
} from '@/layout/initial-inscription'
import { InterviewModule } from '@/layout/initial-inscription/Interview-Module/InterviewModule'
import { Forms } from '@/types/forms/formStatus'

export const contentTextLabel = (steps: Forms[]): string => {
    const lastUncompletedForm = steps.find((step) => !step.completed)

    return lastUncompletedForm ? lastUncompletedForm.formName : ''
}

// Normaliza el nombre del paso para hacer el mapeo tolerante a acentos y espacios
const normalizeName = (name: string): string =>
    name
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')

export const AddModuleComponent = (steps: Forms): void => {
    const name = normalizeName(steps.formName)

    const map: Record<string, any> = {
        bienvenida: WelcomeModule,
        conozcamonos: MeetUsModule,
        'cuentanos sobre ti': AboutYouModule,
        'sube tus documentos': UploadFilesForm,
        entrevista: InterviewModule,
        pago: EnrollmentOrderModule,
        proyeccion: ProjectionModule
    }

    const component = map[name]

    if (component) {
        steps.component = component
        console.log('[AddModuleComponent] Mapped', {
            raw: steps.formName,
            normalized: name,
            component: component.name || 'Anonymous'
        })
    } else {
        console.warn('[AddModuleComponent] No component found', {
            raw: steps.formName,
            normalized: name
        })
    }
}

// TEMPORAL: Función para agregar Orden de Matrícula para visualización
/*export const addEnrollmentOrderIfNeeded = (
    forms: Forms[],
    AddModuleComponent: (form: Forms) => void
): void => {
    const hasEntrevista = forms.some((form) => form.formName === 'Entrevista')
    const hasOrdenMatricula = forms.some(
        (form) => form.formName === 'Orden de Matrícula'
    )

    if (hasEntrevista && !hasOrdenMatricula) {
        const ordenMatriculaForm: Forms = {
            formName: 'Orden de Matrícula',
            completed: false,
            idForm: 999, // ID temporal
            component: null, // Se asignará en AddModuleComponent
            idLastForm: 1
        }

        AddModuleComponent(ordenMatriculaForm)
        forms.push(ordenMatriculaForm)
    }
}*/
